import { useState } from "react";
import OptionGreekTable from "../../Tables/OptionGreek/OptionGreekTable";
import SearchParamUI from "./SearchParamUI";
import {
  IOptionGreekSearchParam,
  OptionGreekOptionType,
} from "../../Interfaces/optionGreek";
import CheckBox from "../../Components/Checkbox";

const OptionGreek = () => {
  const [showHiddenCols, setShowHiddenCols] = useState(false);
  const [searchParam, setSearchParam] = useState<IOptionGreekSearchParam>({
    optionType: OptionGreekOptionType.Call,
  } as IOptionGreekSearchParam);

  const submitHandler = (searchParam: IOptionGreekSearchParam) => {
    setSearchParam(searchParam);
  };

  return (
    <div className="m-auto flex flex-row justify-start items-start gap-3 h-screen mt-8 w-full px-5">
      <div className="flex flex-col justify-start items-start gap-3">
        <SearchParamUI
          onSubmit={submitHandler}
          serverSearchParam={searchParam}
        />
      </div>
      <div className="max-w-max overflow-auto relative pt-10 mx-auto">
        <div className="absolute -top-0 z-50 right-0">
          <CheckBox
            checked={showHiddenCols}
            label="نمایش تمامی ستون ها"
            name=""
            onChange={(_, v) => setShowHiddenCols(v)}
          />
        </div>
        <OptionGreekTable
          showHiddenCols={showHiddenCols}
          searchParam={searchParam}
        />
      </div>
    </div>
  );
};

export default OptionGreek;
